import {
  Box,
  SxProps,
  Theme,
  Typography,
  capitalize,
  useTheme,
} from '@mui/material';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import Section from './Section';
import useSubscriptionPortal from '../../hooks/subscriptions/useSubscriptionPortal';
import useGetSubscriptionFromStripe from '../../hooks/subscriptions/useGetSubscriptionFromStripe';

const paymentMethodButtonStyle: SxProps<Theme> = {
  borderRadius: '10px',
  paddingBlock: '12px',
  paddingInline: '16px',
  typography: 'subtitle2',
};

function PaymentMethodSection() {
  const theme = useTheme();

  const onError = () => {
    toast.error('Failed to update payment method.');
  };

  const stripeQuery = useGetSubscriptionFromStripe();
  const { paymentMethod } = stripeQuery.data || {};

  const {
    launchPortalMutation,
    isPendingUpdatePayment,
    isSuccessUpdatePayment,
  } = useSubscriptionPortal({ onError });

  const isUpdatePaymentDisabled =
    isPendingUpdatePayment || isSuccessUpdatePayment;

  const onUpdatePaymentMethod = async () =>
    launchPortalMutation.mutate(
      !paymentMethod ? 'payment_method_update' : undefined,
    );

  return (
    <Section title="Payment Method">
      <Box
        borderRadius={2.5}
        bgcolor={theme.palette.lightGrey.main}
        paddingY={2.5}
        paddingX={2}
        display="flex"
        alignItems="center"
        gap={2.5}>
        <PaymentsOutlinedIcon fontSize="small" />
        <Box flex={1} display="flex" flexDirection="column" gap={0.5}>
          <Typography variant="body2" color="text.secondary">
            Payment Method
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {paymentMethod && paymentMethod.type === 'card'
              ? `${capitalize(paymentMethod.brand)} ending in ${
                  paymentMethod.last4
                }`
              : paymentMethod?.type === 'link'
              ? 'Saved via Link'
              : paymentMethod?.type === 'us_bank_account'
              ? `${paymentMethod.brand} ending in ${paymentMethod.last4}`
              : 'None added yet'}
          </Typography>
        </Box>
        {!!paymentMethod && (
          <LoadingButton
            loading={isPendingUpdatePayment || isSuccessUpdatePayment}
            onClick={onUpdatePaymentMethod}
            disabled={isUpdatePaymentDisabled}
            aria-disabled={isUpdatePaymentDisabled}
            variant="contained"
            sx={{
              ...paymentMethodButtonStyle,
              backgroundColor: '#FFFFFF',
            }}
            color="inherit">
            Manage
          </LoadingButton>
        )}
        {!paymentMethod && (
          <LoadingButton
            loading={isPendingUpdatePayment || isSuccessUpdatePayment}
            onClick={onUpdatePaymentMethod}
            disabled={isUpdatePaymentDisabled}
            aria-disabled={isUpdatePaymentDisabled}
            variant="contained"
            sx={paymentMethodButtonStyle}>
            Add Payment Method
          </LoadingButton>
        )}
      </Box>
    </Section>
  );
}

export default PaymentMethodSection;
